exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sewingLaborRratePage[data-v-5bf8d547]{position:relative;padding:10px}.sewingLaborRratePage .table-footer[data-v-5bf8d547]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:10px 0;border:1px solid #dcdee2;border-top:none;background-color:#f8f8f9}.sewingLaborRratePage .table-footer .seat[data-v-5bf8d547]{width:120px}.sewingLaborRratePage .table-footer .flex1[data-v-5bf8d547]{-webkit-box-flex:1;-ms-flex:1;flex:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}", ""]);

// exports
